import React from "react";
import { Check, ChevronRight } from "lucide-react";

export interface Step {
  id: number;
  label: string;
}

interface StepperProps {
  currentStep: number;
  steps: Step[];
}

const Stepper: React.FC<StepperProps> = ({
  currentStep,
  steps,
}) => {
  return (
    <div
      className="
        flex
        items-center
        justify-center
        gap-1
        p-0.5
      "
    >
      {steps.map((step, index) => {
        const isCompleted = currentStep > step.id;
        const isActive = currentStep === step.id;

        return (
          <React.Fragment key={step.id}>
            <div
              className="
                flex
                items-center
                gap-2
                rounded-md
                px-3
                py-2
              "
            >
              {isCompleted ? (
                <div
                  className="
                    flex
                    h-6
                    w-6
                    items-center
                    justify-center
                    rounded-full
                    bg-[#16A34A]
                  "
                >
                  <Check
                    size={12}
                    strokeWidth={2.5}
                    className="text-white"
                  />
                </div>
              ) : (
                <div
                  className={`
                    flex
                    h-6
                    w-6
                    items-center
                    justify-center
                    rounded-full
                    text-[12px]
                    font-semibold
                    text-white
                    ${isActive ? "bg-[#788AF7]" : "bg-[#9CA3AF]"}
                  `}
                >
                  {step.id}
                </div>
              )}

              <span
                className={`
                  text-[12px]
                  leading-4
                  font-medium
                  ${
                    isActive || isCompleted
                      ? "text-[#0A0A0A]"
                      : "text-[#737373]"
                  }
                `}
              >
                {step.label}
              </span>
            </div>

            {index < steps.length - 1 && (
              <ChevronRight
                size={16}
                strokeWidth={1.75}
                className="text-[#737373]"
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;